<template>
  <div id="industry_proposal_tab_selection">
    <new-filters-menu v-if="!isMobile" class="mb-4" show-outdated-warning :filters="['industrias', 'industria-mecanica']" />
    <offer-schedule-list />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {
    OfferScheduleList: () => import('@/modules/industria/ofertas-trade/views/components/offer-schedule-list/OfferScheduleList.vue'),
    NewFiltersMenu: () => import('@/components/filters-menu/NewFiltersMenu.vue'),
  },
  mounted() {
    this.clearNotifications('AVAILABLE_TRADE_OFFERS')
  },
  methods: {
    ...mapActions(['clearNotifications']),
  },
}
</script>
